export default __webpack_public_path__ + "ec5e3a839bc158a9fe163196737e8730.svg";